import Roles from "../../../config/roles";

// Deben coincidir con ROLES_PREPARADOR del backend
// (../api/src/modules/inventarios/inventario.constants.js): un rol que no esté allí responde 400 al crear
const ROLES_PREPARADOR = [Roles.REPONEDOR.role, Roles.ALMACEN.role, Roles.ADMIN.role];

/**
 * Indica si un usuario (forma de UsuariosService.list) puede recibir inventarios
 * @param {{rol?: {nombre?: string}}} usuario - Usuario con su rol
 * @returns {boolean} true si su rol es reponedor, almacén o admin
 */
export const esPreparador = (usuario) => ROLES_PREPARADOR.includes(String(usuario?.rol?.nombre ?? "").toLowerCase());
